import React from 'react';

export interface FormFieldProps {
  label?: string;
  error?: string;
  hint?: string;
  required?: boolean;
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
}

const FormField = React.forwardRef<HTMLDivElement, FormFieldProps>(
  ({ label, error, hint, required, children, className = '', htmlFor }, ref) => (
    <div ref={ref} className={className}>
      {label && (
        <label
          htmlFor={htmlFor}
          className="text-2xs text-content-muted uppercase tracking-wider block mb-1.5"
        >
          {label}
          {required && <span className="text-status-error ml-0.5">*</span>}
        </label>
      )}
      {children}
      {error && <p className="text-2xs text-status-error mt-1">{error}</p>}
      {hint && !error && <p className="text-2xs text-content-faint mt-1">{hint}</p>}
    </div>
  ),
);

FormField.displayName = 'FormField';

export default FormField;
